// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ap-bg: #f1ebdf;
  --ap-surface: rgba(253, 250, 244, 0.8);
  --ap-card: rgba(255, 252, 247, 0.9);
  --ap-ink: #15130f;
  --ap-muted: rgba(21, 19, 15, 0.65);
  --ap-line: rgba(21, 19, 15, 0.12);
  --ap-accent: #b24a2c;
  --ap-accent-soft: rgba(178, 74, 44, 0.15);
  --ap-teal: #205f61;
  --ap-shadow: 0 28px 80px rgba(34, 25, 13, 0.14);
}

.ap-page {
  position: relative;
  height: 100dvh;
  padding: 18px 24px 20px;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(32, 95, 97, 0.13), transparent 28%),
    radial-gradient(circle at 82% 18%, rgba(178, 74, 44, 0.16), transparent 24%),
    linear-gradient(180deg, #f5efe4 0%, var(--ap-bg) 42%, #efe7d8 100%);
  color: var(--ap-ink);
  font-family: "Geist Sans", sans-serif;
}

.ap-page::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(rgba(21, 19, 15, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(21, 19, 15, 0.02) 1px, transparent 1px);
  background-size: 100% 38px, 38px 100%;
  pointer-events: none;
  opacity: 0.5;
}

.ap-noise {
  position: absolute;
  inset: 0;
  opacity: 0.12;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(0, 0, 0, 0.08) 0.8px, transparent 0.8px),
    radial-gradient(circle at 80% 30%, rgba(0, 0, 0, 0.05) 0.7px, transparent 0.7px),
    radial-gradient(circle at 40% 80%, rgba(0, 0, 0, 0.05) 0.8px, transparent 0.8px);
  background-size: 18px 18px, 23px 23px, 31px 31px;
  pointer-events: none;
}

.ap-halo {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  opacity: 0.7;
  animation: apFloat 16s ease-in-out infinite;
}

.ap-halo--one {
  top: 12%;
  right: -8%;
  width: 340px;
  height: 340px;
  border: 1px solid rgba(32, 95, 97, 0.28);
}

.ap-halo--two {
  bottom: -80px;
  left: 38%;
  width: 260px;
  height: 260px;
  border: 1px solid rgba(178, 74, 44, 0.22);
  animation-delay: -6s;
}

.ap-topbar,
.ap-shell {
  position: relative;
  z-index: 1;
}

.ap-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto 14px;
}

.ap-brand {
  display: inline-flex;
  align-items: center;
  color: var(--ap-ink);
  text-decoration: none;
}

.ap-brand__logo {
  display: block;
  width: 120px;
  height: auto;
}

.ap-topbar__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.ap-pill,
.ap-powered {
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid var(--ap-line);
  background: rgba(255, 255, 255, 0.45);
  color: var(--ap-muted);
  font-size: 0.88rem;
}

.ap-powered {
  color: var(--ap-teal);
  border-color: rgba(32, 95, 97, 0.22);
}

.ap-powered--link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;
}

.ap-powered--link:hover {
  transform: translateY(-1px);
  border-color: rgba(32, 95, 97, 0.34);
  background: rgba(255, 255, 255, 0.64);
}

.ap-shell {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(520px, 0.98fr);
  gap: 34px;
  align-items: start;
  max-width: 1400px;
  margin: 0 auto;
  height: calc(100dvh - 92px);
}

.ap-copy {
  display: grid;
  grid-template-rows: auto auto;
  align-content: start;
  gap: 22px;
  min-width: 0;
  min-height: 0;
  padding: 10px 8px 6px 6px;
}

.ap-copy__hero {
  display: grid;
  align-content: start;
  gap: 14px;
  max-width: 640px;
}

.ap-copy__support {
  display: grid;
  gap: 16px;
  align-content: start;
}

.ap-kicker {
  display: inline-block;
  margin-bottom: 0;
  padding: 8px 14px;
  border: 1px solid rgba(178, 74, 44, 0.18);
  border-radius: 999px;
  background: rgba(178, 74, 44, 0.08);
  color: var(--ap-accent);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.ap-title {
  margin: 0;
  font-family: 'Geist Sans', system-ui, sans-serif;
  font-size: clamp(1.95rem, 1.4rem + 1.5vw + 0.55vh, 3.45rem);
  line-height: 0.98;
  letter-spacing: -0.03em;
  max-width: 100%;
}

.ap-title__line {
  display: block;
}

.ap-title__line--nowrap {
  white-space: nowrap;
}

.ap-summary {
  max-width: 560px;
  margin: 0;
  color: var(--ap-muted);
  font-size: 1rem;
  line-height: 1.5;
}

.ap-process {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

.ap-process__card,
.ap-gallery {
  position: relative;
  padding: 15px 16px 14px;
  border: 1px solid var(--ap-line);
  border-radius: 22px;
  background: rgba(255, 252, 247, 0.52);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(12px);
}

.ap-process__step {
  display: inline-block;
  margin-bottom: 8px;
  color: var(--ap-accent);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.ap-process__card p {
  margin: 0;
  color: var(--ap-muted);
  line-height: 1.45;
  font-size: 0.92rem;
}

.ap-gallery__header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.ap-gallery__label {
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ap-teal);
}

.ap-gallery__header p {
  margin: 0;
  max-width: 380px;
  color: var(--ap-muted);
  font-size: 0.88rem;
  line-height: 1.35;
  text-align: right;
}

.ap-gallery__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.ap-gallery-card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 68px;
  padding: 12px 14px;
  border: 1px solid rgba(21, 19, 15, 0.12);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.56);
  cursor: pointer;
  text-align: left;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.ap-gallery-card:hover {
  transform: translateY(-2px);
  border-color: rgba(178, 74, 44, 0.28);
  box-shadow: 0 18px 30px rgba(34, 25, 13, 0.12);
}

.ap-gallery-card__icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 12px;
  background: rgba(178, 74, 44, 0.1);
  color: var(--ap-accent);
}

.ap-gallery-card__icon svg {
  width: 18px;
  height: 18px;
}

.ap-gallery-card__content {
  display: block;
  min-width: 0;
}

.ap-gallery-card__content strong {
  display: block;
  color: var(--ap-ink);
  font-size: 0.92rem;
  line-height: 1.2;
}

.ap-modal__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ap-panel-wrap {
  align-self: start;
  min-height: 0;
  padding-bottom: 0;
}

.ap-panel {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: auto;
  padding: 22px;
  border: 1px solid rgba(21, 19, 15, 0.12);
  border-radius: 32px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.75), rgba(255, 250, 244, 0.84)),
    var(--ap-card);
  box-shadow: var(--ap-shadow);
  backdrop-filter: blur(24px);
}

.ap-panel::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  border: 1px solid rgba(255, 255, 255, 0.55);
  pointer-events: none;
}

.ap-panel__header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 18px;
  margin-bottom: 14px;
}

.ap-panel__header h2,
.ap-section__header h3 {
  margin: 0;
}

.ap-panel__header h2 {
  font-size: 2.05rem;
  line-height: 1.04;
  letter-spacing: -0.03em;
}

.ap-panel__eyebrow {
  margin: 0 0 8px;
  color: var(--ap-accent);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.ap-panel__microcopy,
.ap-section__header p {
  margin: 6px 0 0;
  color: var(--ap-muted);
  line-height: 1.4;
  font-size: 0.92rem;
}

.ap-panel__microcopy {
  text-align: right;
  white-space: nowrap;
}

.ap-upload {
  width: 100%;
  margin-bottom: 14px;
  padding: 0;
  border: 1px dashed rgba(21, 19, 15, 0.18);
  border-radius: 28px;
  background:
    linear-gradient(135deg, rgba(32, 95, 97, 0.06), rgba(178, 74, 44, 0.08)),
    rgba(250, 245, 237, 0.82);
  color: var(--ap-ink);
  text-align: left;
  cursor: pointer;
  transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
}

.ap-upload:hover,
.ap-upload--dragging {
  transform: translateY(-1px);
  border-color: rgba(178, 74, 44, 0.45);
  box-shadow: 0 18px 40px rgba(178, 74, 44, 0.09);
}

.ap-upload--filled {
  border-style: solid;
}

.ap-hidden-input {
  display: none;
}

.ap-upload__empty,
.ap-upload__filled {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  min-height: 118px;
  padding: 18px 20px;
}

.ap-upload__empty {
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.ap-upload__icon {
  display: grid;
  place-items: center;
  width: 62px;
  height: 62px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.66);
  color: var(--ap-accent);
}

.ap-upload__icon svg {
  width: 28px;
  height: 28px;
}

.ap-upload__empty strong,
.ap-upload__filled strong,
.ap-choice strong,
.ap-duration strong {
  font-size: 0.98rem;
}

.ap-upload__empty span,
.ap-upload__filled span,
.ap-choice span,
.ap-duration span {
  color: var(--ap-muted);
}

.ap-upload__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 54px;
  height: 54px;
  padding: 0 14px;
  border-radius: 18px;
  background: rgba(32, 95, 97, 0.1);
  color: var(--ap-teal);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.ap-upload__details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ap-upload__action {
  color: var(--ap-accent);
  font-weight: 700;
}

.ap-section {
  margin-top: 12px;
}

.ap-section__header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
}

.ap-section__header--compact {
  margin-bottom: 16px;
}

.ap-index {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(178, 74, 44, 0.1);
  color: var(--ap-accent);
  font-size: 0.9rem;
  font-weight: 700;
  flex-shrink: 0;
}

.ap-choice-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.ap-choice,
.ap-duration {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  padding: 14px;
  border: 1px solid var(--ap-line);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.56);
  color: var(--ap-ink);
  text-align: left;
  cursor: pointer;
  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;
}

.ap-choice:hover,
.ap-duration:hover,
.ap-choice--active,
.ap-duration--active {
  transform: translateY(-1px);
  border-color: rgba(178, 74, 44, 0.34);
  background: linear-gradient(180deg, rgba(178, 74, 44, 0.08), rgba(255, 255, 255, 0.8));
}

.ap-choice__eyebrow {
  color: var(--ap-accent);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.ap-duration-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.ap-brief {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  margin-top: 12px;
  padding: 16px;
  border: 1px solid var(--ap-line);
  border-radius: 22px;
  background: rgba(248, 243, 234, 0.72);
}

.ap-brief__preview {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: "Geist Sans", sans-serif;
  font-size: 0.86rem;
  line-height: 1.46;
  color: var(--ap-muted);
}

.ap-error {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid rgba(178, 74, 44, 0.2);
  background: rgba(178, 74, 44, 0.08);
  color: #7b2e18;
}

.ap-submit-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-top: 14px;
}

.ap-submit__copy {
  max-width: 420px;
  color: var(--ap-muted);
  line-height: 1.45;
  font-size: 0.92rem;
}

.ap-submit {
  flex-shrink: 0;
  min-width: 240px;
  padding: 16px 22px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--ap-accent), #c56b3b);
  color: #fffaf5;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: 0 18px 34px rgba(178, 74, 44, 0.24);
  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

.ap-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 22px 38px rgba(178, 74, 44, 0.3);
}

.ap-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ap-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: grid;
  place-items: center;
  padding: 24px;
  border: 0;
  background: rgba(13, 11, 8, 0.46);
  backdrop-filter: blur(12px);
}

.ap-modal {
  display: grid;
  grid-template-columns: minmax(280px, 1.1fr) minmax(260px, 0.9fr);
  width: min(920px, 100%);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 28px;
  background: rgba(255, 251, 244, 0.96);
  box-shadow: 0 32px 80px rgba(16, 12, 8, 0.25);
}

.ap-modal__media {
  position: relative;
  min-height: 360px;
  background: #d8d0c3;
}

.ap-modal__play {
  position: absolute;
  inset: 50% auto auto 50%;
  display: grid;
  place-items: center;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: rgba(255, 248, 242, 0.88);
  color: var(--ap-accent);
  transform: translate(-50%, -50%);
}

.ap-modal__play svg {
  width: 28px;
  height: 28px;
}

.ap-modal__body {
  display: grid;
  align-content: center;
  gap: 12px;
  padding: 32px;
}

.ap-modal__eyebrow {
  color: var(--ap-accent);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.ap-modal__body h2 {
  margin: 0;
  font-size: 1.7rem;
  line-height: 1.08;
}

.ap-modal__body p {
  margin: 0;
  color: var(--ap-muted);
  line-height: 1.55;
}

.ap-modal__close {
  justify-self: center;
  min-width: 120px;
  margin-top: 8px;
  padding: 12px 18px;
  border: 1px solid rgba(21, 19, 15, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  color: var(--ap-ink);
  font-weight: 600;
  cursor: pointer;
}

.ap-signoff {
  position: absolute;
  left: 50%;
  bottom: 12px;
  z-index: 1;
  transform: translateX(-50%);
  color: rgba(21, 19, 15, 0.46);
  font-size: 0.7rem;
  letter-spacing: 0.04em;
}

@keyframes apFloat {
  0%,
  100% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, -18px, 0);
  }
}

@media (max-width: 1180px) {
  .ap-shell {
    grid-template-columns: 1fr;
    height: auto;
  }

  .ap-copy {
    padding-top: 0;
    order: 2;
  }

  .ap-panel-wrap {
    order: 1;
  }

  .ap-choice-grid {
    grid-template-columns: 1fr;
  }

  .ap-title {
    max-width: none;
  }

  .ap-title__line--nowrap {
    white-space: normal;
  }

  .ap-panel__header {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .ap-panel__microcopy {
    text-align: left;
    white-space: normal;
  }

  .ap-gallery__header {
    display: grid;
    gap: 6px;
  }

  .ap-gallery__header p {
    max-width: none;
    text-align: left;
  }
}

@media (max-width: 1480px) and (min-width: 1181px) {
  .ap-shell {
    grid-template-columns: minmax(0, 0.88fr) minmax(500px, 1fr);
    gap: 28px;
  }

  .ap-title {
    font-size: clamp(1.85rem, 1.2rem + 1.2vw + 0.45vh, 3.05rem);
  }
}

@media (max-height: 920px) and (min-width: 821px) {
  .ap-title {
    font-size: clamp(1.85rem, 1.2rem + 1.15vw + 0.45vh, 2.95rem);
  }
}

@media (max-height: 820px) and (min-width: 821px) {
  .ap-title {
    font-size: clamp(1.7rem, 1.1rem + 0.95vw + 0.3vh, 2.55rem);
  }
}

@media (max-width: 820px) {
  .ap-page {
    height: auto;
    min-height: 100dvh;
    padding: 16px;
    overflow-y: auto;
  }

  .ap-topbar {
    margin-bottom: 18px;
  }

  .ap-title {
    font-size: clamp(2.8rem, 12vw, 4.2rem);
  }

  .ap-process,
  .ap-gallery__grid,
  .ap-duration-grid,
  .ap-submit-row {
    grid-template-columns: 1fr;
    flex-direction: column;
  }

  .ap-panel {
    padding: 20px;
    border-radius: 28px;
  }

  .ap-submit-row,
  .ap-upload__filled {
    flex-direction: column;
    align-items: flex-start;
  }

  .ap-submit {
    width: 100%;
  }

  .ap-modal {
    grid-template-columns: 1fr;
  }

  .ap-modal__media {
    min-height: 220px;
  }

  .ap-signoff {
    position: static;
    margin-top: 12px;
    text-align: center;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/AcademicPapersPage.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,mCAAmC;EACnC,iBAAiB;EACjB,kCAAkC;EAClC,iCAAiC;EACjC,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB;;;uEAGqE;EACrE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;uEAEqE;EACrE,qCAAqC;EACrC,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb;;;oFAGkF;EAClF,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,oBAAoB;EACpB,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,2DAA2D;EAC3D,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB;;kBAEgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,yCAAyC;EACzC,mBAAmB;EACnB;;6BAE2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;;;;EAIE,2BAA2B;EAC3B,qCAAqC;EACrC,sFAAsF;AACxF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,8DAA8D;EAC9D,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,+CAA+C;EAC/C,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,+BAA+B;EACjC;EACA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;;;IAIE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap\");\n\n:root {\n  --ap-bg: #f1ebdf;\n  --ap-surface: rgba(253, 250, 244, 0.8);\n  --ap-card: rgba(255, 252, 247, 0.9);\n  --ap-ink: #15130f;\n  --ap-muted: rgba(21, 19, 15, 0.65);\n  --ap-line: rgba(21, 19, 15, 0.12);\n  --ap-accent: #b24a2c;\n  --ap-accent-soft: rgba(178, 74, 44, 0.15);\n  --ap-teal: #205f61;\n  --ap-shadow: 0 28px 80px rgba(34, 25, 13, 0.14);\n}\n\n.ap-page {\n  position: relative;\n  height: 100dvh;\n  padding: 18px 24px 20px;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at top left, rgba(32, 95, 97, 0.13), transparent 28%),\n    radial-gradient(circle at 82% 18%, rgba(178, 74, 44, 0.16), transparent 24%),\n    linear-gradient(180deg, #f5efe4 0%, var(--ap-bg) 42%, #efe7d8 100%);\n  color: var(--ap-ink);\n  font-family: \"Geist Sans\", sans-serif;\n}\n\n.ap-page::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(rgba(21, 19, 15, 0.025) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(21, 19, 15, 0.02) 1px, transparent 1px);\n  background-size: 100% 38px, 38px 100%;\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.ap-noise {\n  position: absolute;\n  inset: 0;\n  opacity: 0.12;\n  background-image:\n    radial-gradient(circle at 20% 20%, rgba(0, 0, 0, 0.08) 0.8px, transparent 0.8px),\n    radial-gradient(circle at 80% 30%, rgba(0, 0, 0, 0.05) 0.7px, transparent 0.7px),\n    radial-gradient(circle at 40% 80%, rgba(0, 0, 0, 0.05) 0.8px, transparent 0.8px);\n  background-size: 18px 18px, 23px 23px, 31px 31px;\n  pointer-events: none;\n}\n\n.ap-halo {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(2px);\n  opacity: 0.7;\n  animation: apFloat 16s ease-in-out infinite;\n}\n\n.ap-halo--one {\n  top: 12%;\n  right: -8%;\n  width: 340px;\n  height: 340px;\n  border: 1px solid rgba(32, 95, 97, 0.28);\n}\n\n.ap-halo--two {\n  bottom: -80px;\n  left: 38%;\n  width: 260px;\n  height: 260px;\n  border: 1px solid rgba(178, 74, 44, 0.22);\n  animation-delay: -6s;\n}\n\n.ap-topbar,\n.ap-shell {\n  position: relative;\n  z-index: 1;\n}\n\n.ap-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  max-width: 1400px;\n  margin: 0 auto 14px;\n}\n\n.ap-brand {\n  display: inline-flex;\n  align-items: center;\n  color: var(--ap-ink);\n  text-decoration: none;\n}\n\n.ap-brand__logo {\n  display: block;\n  width: 120px;\n  height: auto;\n}\n\n.ap-topbar__meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.ap-pill,\n.ap-powered {\n  padding: 10px 14px;\n  border-radius: 999px;\n  border: 1px solid var(--ap-line);\n  background: rgba(255, 255, 255, 0.45);\n  color: var(--ap-muted);\n  font-size: 0.88rem;\n}\n\n.ap-powered {\n  color: var(--ap-teal);\n  border-color: rgba(32, 95, 97, 0.22);\n}\n\n.ap-powered--link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;\n}\n\n.ap-powered--link:hover {\n  transform: translateY(-1px);\n  border-color: rgba(32, 95, 97, 0.34);\n  background: rgba(255, 255, 255, 0.64);\n}\n\n.ap-shell {\n  display: grid;\n  grid-template-columns: minmax(0, 0.92fr) minmax(520px, 0.98fr);\n  gap: 34px;\n  align-items: start;\n  max-width: 1400px;\n  margin: 0 auto;\n  height: calc(100dvh - 92px);\n}\n\n.ap-copy {\n  display: grid;\n  grid-template-rows: auto auto;\n  align-content: start;\n  gap: 22px;\n  min-width: 0;\n  min-height: 0;\n  padding: 10px 8px 6px 6px;\n}\n\n.ap-copy__hero {\n  display: grid;\n  align-content: start;\n  gap: 14px;\n  max-width: 640px;\n}\n\n.ap-copy__support {\n  display: grid;\n  gap: 16px;\n  align-content: start;\n}\n\n.ap-kicker {\n  display: inline-block;\n  margin-bottom: 0;\n  padding: 8px 14px;\n  border: 1px solid rgba(178, 74, 44, 0.18);\n  border-radius: 999px;\n  background: rgba(178, 74, 44, 0.08);\n  color: var(--ap-accent);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.ap-title {\n  margin: 0;\n  font-family: 'Geist Sans', system-ui, sans-serif;\n  font-size: clamp(1.95rem, 1.4rem + 1.5vw + 0.55vh, 3.45rem);\n  line-height: 0.98;\n  letter-spacing: -0.03em;\n  max-width: 100%;\n}\n\n.ap-title__line {\n  display: block;\n}\n\n.ap-title__line--nowrap {\n  white-space: nowrap;\n}\n\n.ap-summary {\n  max-width: 560px;\n  margin: 0;\n  color: var(--ap-muted);\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.ap-process {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin: 0;\n}\n\n.ap-process__card,\n.ap-gallery {\n  position: relative;\n  padding: 15px 16px 14px;\n  border: 1px solid var(--ap-line);\n  border-radius: 22px;\n  background: rgba(255, 252, 247, 0.52);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45);\n  backdrop-filter: blur(12px);\n}\n\n.ap-process__step {\n  display: inline-block;\n  margin-bottom: 8px;\n  color: var(--ap-accent);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n}\n\n.ap-process__card p {\n  margin: 0;\n  color: var(--ap-muted);\n  line-height: 1.45;\n  font-size: 0.92rem;\n}\n\n.ap-gallery__header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.ap-gallery__label {\n  font-size: 0.74rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ap-teal);\n}\n\n.ap-gallery__header p {\n  margin: 0;\n  max-width: 380px;\n  color: var(--ap-muted);\n  font-size: 0.88rem;\n  line-height: 1.35;\n  text-align: right;\n}\n\n.ap-gallery__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.ap-gallery-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 68px;\n  padding: 12px 14px;\n  border: 1px solid rgba(21, 19, 15, 0.12);\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.56);\n  cursor: pointer;\n  text-align: left;\n  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n}\n\n.ap-gallery-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(178, 74, 44, 0.28);\n  box-shadow: 0 18px 30px rgba(34, 25, 13, 0.12);\n}\n\n.ap-gallery-card__icon {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: rgba(178, 74, 44, 0.1);\n  color: var(--ap-accent);\n}\n\n.ap-gallery-card__icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.ap-gallery-card__content {\n  display: block;\n  min-width: 0;\n}\n\n.ap-gallery-card__content strong {\n  display: block;\n  color: var(--ap-ink);\n  font-size: 0.92rem;\n  line-height: 1.2;\n}\n\n.ap-modal__image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ap-panel-wrap {\n  align-self: start;\n  min-height: 0;\n  padding-bottom: 0;\n}\n\n.ap-panel {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: auto;\n  padding: 22px;\n  border: 1px solid rgba(21, 19, 15, 0.12);\n  border-radius: 32px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.75), rgba(255, 250, 244, 0.84)),\n    var(--ap-card);\n  box-shadow: var(--ap-shadow);\n  backdrop-filter: blur(24px);\n}\n\n.ap-panel::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  pointer-events: none;\n}\n\n.ap-panel__header {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 18px;\n  margin-bottom: 14px;\n}\n\n.ap-panel__header h2,\n.ap-section__header h3 {\n  margin: 0;\n}\n\n.ap-panel__header h2 {\n  font-size: 2.05rem;\n  line-height: 1.04;\n  letter-spacing: -0.03em;\n}\n\n.ap-panel__eyebrow {\n  margin: 0 0 8px;\n  color: var(--ap-accent);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.ap-panel__microcopy,\n.ap-section__header p {\n  margin: 6px 0 0;\n  color: var(--ap-muted);\n  line-height: 1.4;\n  font-size: 0.92rem;\n}\n\n.ap-panel__microcopy {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.ap-upload {\n  width: 100%;\n  margin-bottom: 14px;\n  padding: 0;\n  border: 1px dashed rgba(21, 19, 15, 0.18);\n  border-radius: 28px;\n  background:\n    linear-gradient(135deg, rgba(32, 95, 97, 0.06), rgba(178, 74, 44, 0.08)),\n    rgba(250, 245, 237, 0.82);\n  color: var(--ap-ink);\n  text-align: left;\n  cursor: pointer;\n  transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;\n}\n\n.ap-upload:hover,\n.ap-upload--dragging {\n  transform: translateY(-1px);\n  border-color: rgba(178, 74, 44, 0.45);\n  box-shadow: 0 18px 40px rgba(178, 74, 44, 0.09);\n}\n\n.ap-upload--filled {\n  border-style: solid;\n}\n\n.ap-hidden-input {\n  display: none;\n}\n\n.ap-upload__empty,\n.ap-upload__filled {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  min-height: 118px;\n  padding: 18px 20px;\n}\n\n.ap-upload__empty {\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n\n.ap-upload__icon {\n  display: grid;\n  place-items: center;\n  width: 62px;\n  height: 62px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.66);\n  color: var(--ap-accent);\n}\n\n.ap-upload__icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.ap-upload__empty strong,\n.ap-upload__filled strong,\n.ap-choice strong,\n.ap-duration strong {\n  font-size: 0.98rem;\n}\n\n.ap-upload__empty span,\n.ap-upload__filled span,\n.ap-choice span,\n.ap-duration span {\n  color: var(--ap-muted);\n}\n\n.ap-upload__badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 54px;\n  height: 54px;\n  padding: 0 14px;\n  border-radius: 18px;\n  background: rgba(32, 95, 97, 0.1);\n  color: var(--ap-teal);\n  font-size: 0.9rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.ap-upload__details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ap-upload__action {\n  color: var(--ap-accent);\n  font-weight: 700;\n}\n\n.ap-section {\n  margin-top: 12px;\n}\n\n.ap-section__header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 10px;\n}\n\n.ap-section__header--compact {\n  margin-bottom: 16px;\n}\n\n.ap-index {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: rgba(178, 74, 44, 0.1);\n  color: var(--ap-accent);\n  font-size: 0.9rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.ap-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.ap-choice,\n.ap-duration {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--ap-line);\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.56);\n  color: var(--ap-ink);\n  text-align: left;\n  cursor: pointer;\n  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;\n}\n\n.ap-choice:hover,\n.ap-duration:hover,\n.ap-choice--active,\n.ap-duration--active {\n  transform: translateY(-1px);\n  border-color: rgba(178, 74, 44, 0.34);\n  background: linear-gradient(180deg, rgba(178, 74, 44, 0.08), rgba(255, 255, 255, 0.8));\n}\n\n.ap-choice__eyebrow {\n  color: var(--ap-accent);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.ap-duration-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.ap-brief {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  margin-top: 12px;\n  padding: 16px;\n  border: 1px solid var(--ap-line);\n  border-radius: 22px;\n  background: rgba(248, 243, 234, 0.72);\n}\n\n.ap-brief__preview {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: \"Geist Sans\", sans-serif;\n  font-size: 0.86rem;\n  line-height: 1.46;\n  color: var(--ap-muted);\n}\n\n.ap-error {\n  margin-top: 16px;\n  padding: 14px 16px;\n  border-radius: 18px;\n  border: 1px solid rgba(178, 74, 44, 0.2);\n  background: rgba(178, 74, 44, 0.08);\n  color: #7b2e18;\n}\n\n.ap-submit-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin-top: 14px;\n}\n\n.ap-submit__copy {\n  max-width: 420px;\n  color: var(--ap-muted);\n  line-height: 1.45;\n  font-size: 0.92rem;\n}\n\n.ap-submit {\n  flex-shrink: 0;\n  min-width: 240px;\n  padding: 16px 22px;\n  border: 0;\n  border-radius: 999px;\n  background: linear-gradient(135deg, var(--ap-accent), #c56b3b);\n  color: #fffaf5;\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n  box-shadow: 0 18px 34px rgba(178, 74, 44, 0.24);\n  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;\n}\n\n.ap-submit:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 22px 38px rgba(178, 74, 44, 0.3);\n}\n\n.ap-submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ap-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 20;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  border: 0;\n  background: rgba(13, 11, 8, 0.46);\n  backdrop-filter: blur(12px);\n}\n\n.ap-modal {\n  display: grid;\n  grid-template-columns: minmax(280px, 1.1fr) minmax(260px, 0.9fr);\n  width: min(920px, 100%);\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 28px;\n  background: rgba(255, 251, 244, 0.96);\n  box-shadow: 0 32px 80px rgba(16, 12, 8, 0.25);\n}\n\n.ap-modal__media {\n  position: relative;\n  min-height: 360px;\n  background: #d8d0c3;\n}\n\n.ap-modal__play {\n  position: absolute;\n  inset: 50% auto auto 50%;\n  display: grid;\n  place-items: center;\n  width: 74px;\n  height: 74px;\n  border-radius: 50%;\n  background: rgba(255, 248, 242, 0.88);\n  color: var(--ap-accent);\n  transform: translate(-50%, -50%);\n}\n\n.ap-modal__play svg {\n  width: 28px;\n  height: 28px;\n}\n\n.ap-modal__body {\n  display: grid;\n  align-content: center;\n  gap: 12px;\n  padding: 32px;\n}\n\n.ap-modal__eyebrow {\n  color: var(--ap-accent);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.ap-modal__body h2 {\n  margin: 0;\n  font-size: 1.7rem;\n  line-height: 1.08;\n}\n\n.ap-modal__body p {\n  margin: 0;\n  color: var(--ap-muted);\n  line-height: 1.55;\n}\n\n.ap-modal__close {\n  justify-self: center;\n  min-width: 120px;\n  margin-top: 8px;\n  padding: 12px 18px;\n  border: 1px solid rgba(21, 19, 15, 0.12);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--ap-ink);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ap-signoff {\n  position: absolute;\n  left: 50%;\n  bottom: 12px;\n  z-index: 1;\n  transform: translateX(-50%);\n  color: rgba(21, 19, 15, 0.46);\n  font-size: 0.7rem;\n  letter-spacing: 0.04em;\n}\n\n@keyframes apFloat {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0);\n  }\n  50% {\n    transform: translate3d(0, -18px, 0);\n  }\n}\n\n@media (max-width: 1180px) {\n  .ap-shell {\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n\n  .ap-copy {\n    padding-top: 0;\n    order: 2;\n  }\n\n  .ap-panel-wrap {\n    order: 1;\n  }\n\n  .ap-choice-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ap-title {\n    max-width: none;\n  }\n\n  .ap-title__line--nowrap {\n    white-space: normal;\n  }\n\n  .ap-panel__header {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .ap-panel__microcopy {\n    text-align: left;\n    white-space: normal;\n  }\n\n  .ap-gallery__header {\n    display: grid;\n    gap: 6px;\n  }\n\n  .ap-gallery__header p {\n    max-width: none;\n    text-align: left;\n  }\n}\n\n@media (max-width: 1480px) and (min-width: 1181px) {\n  .ap-shell {\n    grid-template-columns: minmax(0, 0.88fr) minmax(500px, 1fr);\n    gap: 28px;\n  }\n\n  .ap-title {\n    font-size: clamp(1.85rem, 1.2rem + 1.2vw + 0.45vh, 3.05rem);\n  }\n}\n\n@media (max-height: 920px) and (min-width: 821px) {\n  .ap-title {\n    font-size: clamp(1.85rem, 1.2rem + 1.15vw + 0.45vh, 2.95rem);\n  }\n}\n\n@media (max-height: 820px) and (min-width: 821px) {\n  .ap-title {\n    font-size: clamp(1.7rem, 1.1rem + 0.95vw + 0.3vh, 2.55rem);\n  }\n}\n\n@media (max-width: 820px) {\n  .ap-page {\n    height: auto;\n    min-height: 100dvh;\n    padding: 16px;\n    overflow-y: auto;\n  }\n\n  .ap-topbar {\n    margin-bottom: 18px;\n  }\n\n  .ap-title {\n    font-size: clamp(2.8rem, 12vw, 4.2rem);\n  }\n\n  .ap-process,\n  .ap-gallery__grid,\n  .ap-duration-grid,\n  .ap-submit-row {\n    grid-template-columns: 1fr;\n    flex-direction: column;\n  }\n\n  .ap-panel {\n    padding: 20px;\n    border-radius: 28px;\n  }\n\n  .ap-submit-row,\n  .ap-upload__filled {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .ap-submit {\n    width: 100%;\n  }\n\n  .ap-modal {\n    grid-template-columns: 1fr;\n  }\n\n  .ap-modal__media {\n    min-height: 220px;\n  }\n\n  .ap-signoff {\n    position: static;\n    margin-top: 12px;\n    text-align: center;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
